import React from "react";
import styles from "./vcCompare.module.css";

export default function VcCompare() {
  return <span className={styles.root}>VS.</span>;
}
